module.exports = "/_next/static/images/sellers_1_en-961e57ca158cab71b2cded27b70bf928.png";